import styled from "styled-components";

export const Conteiner = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
`;
export const DivName = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;

    background: #121214;

    width: 100%;
    height: 120px;

    border: 1px solid #212529;

    h2{
        color: #F8F9FA;
        font-weight: 700;
        font-size: 18px;
    }
    p{
        font-weight: 400;
        font-size: 12px;
        color: #868E96;
    }
`;